'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.manyToManyDescriptor = exports.backwardManyToOneDescriptor = exports.backwardOneToOneDescriptor = exports.forwardOneToOneDescriptor = exports.forwardManyToOneDescriptor = exports.attrDescriptor = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function attrDescriptor(fieldName) {
    return {
        get: function get() {
            return this._fields[fieldName];
        },
        set: function set(value) {
            return this.set(fieldName, value);
        },


        enumerable: true,
        configurable: true
    };
}

// Forwards side a Foreign Key: returns one object.
// Also works as forwardsOneToOneDescriptor.
function forwardManyToOneDescriptor(fieldName, declaredToModelName) {
    return {
        get: function get() {
            var currentSession = this.getClass().session;
            var declaredToModel = currentSession[declaredToModelName];
            var toId = this._fields[fieldName];
            if (typeof toId !== 'undefined' && toId !== null) {
                return declaredToModel.withId(toId);
            }
            return undefined;
        },
        set: function set(value) {
            var currentSession = this.getClass().session;
            var declaredToModel = currentSession[declaredToModelName];

            var toId = void 0;
            if (value instanceof declaredToModel) {
                toId = value.getId();
            } else {
                toId = value;
            }

            this.update((0, _defineProperty3.default)({}, fieldName, toId));
        }
    };
}

var forwardOneToOneDescriptor = forwardManyToOneDescriptor;

function backwardOneToOneDescriptor(declaredFieldName, declaredFromModelName) {
    return {
        get: function get() {
            var currentSession = this.getClass().session;
            var declaredFromModel = currentSession[declaredFromModelName];
            var thisId = this.getId();
            var found = void 0;
            try {
                found = declaredFromModel.get((0, _defineProperty3.default)({}, declaredFieldName, thisId));
            } catch (e) {
                return null;
            }
            return found;
        },
        set: function set() {
            throw new Error('Can\'t mutate a reverse one-to-one relation.');
        }
    };
}

// Reverse side of a Foreign Key: returns many objects.
function backwardManyToOneDescriptor(declaredFieldName, declaredFromModelName) {
    return {
        get: function get() {
            var currentSession = this.getClass().session;
            var declaredFromModel = currentSession[declaredFromModelName];
            var thisId = this.getId();
            return declaredFromModel.filter((0, _defineProperty3.default)({}, declaredFieldName, thisId));
        },
        set: function set() {
            throw new Error('Can\'t mutate a reverse many-to-one relation.');
        }
    };
}

// Both sides of Many to Many, use the reverse flag.
function manyToManyDescriptor(declaredFromModelName, declaredToModelName, throughModelName, throughFields, reverse) {
    return {
        get: function get() {
            var currentSession = this.getClass().session;
            var declaredFromModel = currentSession[declaredFromModelName];
            var declaredToModel = currentSession[declaredToModelName];
            var throughModel = currentSession[throughModelName];
            var thisId = this.getId();

            var fromFieldName = throughFields.from;
            var toFieldName = throughFields.to;

            var lookupObj = {};
            if (!reverse) {
                lookupObj[fromFieldName] = thisId;
            } else {
                lookupObj[toFieldName] = thisId;
            }

            var throughQs = throughModel.filter(lookupObj);
            var toIds = throughQs.toRefArray().map(function (obj) {
                return obj[reverse ? fromFieldName : toFieldName];
            });

            var qsFromModel = reverse ? declaredFromModel : declaredToModel;
            var qs = qsFromModel.filter(function (attrs) {
                return (0, _utils.includes)(toIds, attrs[qsFromModel.idAttribute]);
            });

            qs.add = function add() {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                var idsToAdd = args.map(_utils.normalizeEntity);

                var filterWithAttr = reverse ? fromFieldName : toFieldName;

                var existingQs = throughQs.filter(function (through) {
                    return (0, _utils.includes)(idsToAdd, through[filterWithAttr]);
                });

                if (existingQs.exists()) {
                    var existingIds = existingQs.toRefArray().map(function (through) {
                        return through[filterWithAttr];
                    });

                    var toAddModel = reverse ? declaredFromModel.modelName : declaredToModel.modelName;

                    var addFromModel = reverse ? declaredToModel.modelName : declaredFromModel.modelName;
                    throw new Error('Tried to add already existing ' + toAddModel + ' id(s) ' + existingIds + ' to the ' + addFromModel + ' instance with id ' + thisId);
                }

                if (reverse) {
                    idsToAdd.forEach(function (id) {
                        var _throughModel$create;

                        throughModel.create((_throughModel$create = {}, (0, _defineProperty3.default)(_throughModel$create, fromFieldName, id), (0, _defineProperty3.default)(_throughModel$create, toFieldName, thisId), _throughModel$create));
                    });
                } else {
                    idsToAdd.forEach(function (id) {
                        var _throughModel$create2;

                        throughModel.create((_throughModel$create2 = {}, (0, _defineProperty3.default)(_throughModel$create2, fromFieldName, thisId), (0, _defineProperty3.default)(_throughModel$create2, toFieldName, id), _throughModel$create2));
                    });
                }
            };

            qs.clear = function clear() {
                throughQs.delete();
            };

            qs.remove = function remove() {
                for (var _len2 = arguments.length, entities = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    entities[_key2] = arguments[_key2];
                }

                var idsToRemove = entities.map(_utils.normalizeEntity);

                var attrInIdsToRemove = reverse ? fromFieldName : toFieldName;
                var entitiesToDelete = throughQs.filter(function (through) {
                    return (0, _utils.includes)(idsToRemove, through[attrInIdsToRemove]);
                });

                if (entitiesToDelete.count() !== idsToRemove.length) {
                    // Tried deleting non-existing entities.
                    var entitiesToDeleteIds = entitiesToDelete.toRefArray().map(function (through) {
                        return through[attrInIdsToRemove];
                    });

                    var unexistingIds = (0, _difference2.default)(idsToRemove, entitiesToDeleteIds);

                    var toDeleteModel = reverse ? declaredFromModel.modelName : declaredToModel.modelName;

                    var deleteFromModel = reverse ? declaredToModel.modelName : declaredFromModel.modelName;

                    throw new Error('Tried to delete non-existing ' + toDeleteModel + ' id(s) ' + unexistingIds + ' from the ' + deleteFromModel + ' instance with id ' + thisId);
                }

                entitiesToDelete.delete();
            };

            return qs;
        },
        set: function set() {
            throw new Error('Tried setting a M2M field. Please use the related QuerySet methods add and remove.');
        }
    };
}

exports.attrDescriptor = attrDescriptor;
exports.forwardManyToOneDescriptor = forwardManyToOneDescriptor;
exports.forwardOneToOneDescriptor = forwardOneToOneDescriptor;
exports.backwardOneToOneDescriptor = backwardOneToOneDescriptor;
exports.backwardManyToOneDescriptor = backwardManyToOneDescriptor;
exports.manyToManyDescriptor = manyToManyDescriptor;


//////////////////
// WEBPACK FOOTER
// ../~/redux-orm/lib/descriptors.js
// module id = 1130
// module chunks = 0